(() => {
  const section = document.querySelector('.hx-meta.hx-scroll-trigger');
  if (!section) return;

  // Per-element delays (kicker/title)
  section.querySelectorAll('[data-hx-delay]').forEach(el => {
    el.style.transitionDelay = el.getAttribute('data-hx-delay') || '0ms';
  });

  // Stagger cards
  const base = 140;   // ms
  const step = 110;   // ms
  section.querySelectorAll('[data-hx-stagger]').forEach(el => {
    const i = parseInt(el.getAttribute('data-hx-stagger') || '0', 10);
    el.style.transitionDelay = (base + (i * step)) + 'ms';
  });

  const reveal = () => section.classList.add('hx-inview');

  if (!('IntersectionObserver' in window)) {
    reveal();
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        reveal();
        io.disconnect(); // trigger once
      }
    });
  }, { threshold: 0.18 });

  io.observe(section);
})();
